export default async function deviceFetch(url, opts = {}) {
  const { deviceToken, body, headers, ...rest } = opts;

  if (!deviceToken) {
    const err = new Error("DEVICE_TOKEN_MISSING");
    err.code = "DEVICE_TOKEN_MISSING";
    throw err;
  }

  const h = new Headers(headers || {});
  h.set("X-Device-Token", deviceToken);

  let finalBody = body;
  if (body && !(body instanceof FormData) && typeof body === "object") {
    h.set("Content-Type", "application/json");
    finalBody = JSON.stringify(body);
  }

  const res = await fetch(url, {
    ...rest,
    headers: h,
    body: finalBody,
  });

  if (res.status === 401) {
    const err = new Error("DEVICE_UNAUTHORIZED");
    err.code = "DEVICE_UNAUTHORIZED";
    throw err;
  }
  if (res.status === 403) {
    const err = new Error("DEVICE_FORBIDDEN");
    err.code = "DEVICE_FORBIDDEN";
    throw err;
  }

  return res;
}